<template>
  <div style="overflow: hidden">
    <div class="w-full">
      <vs-textarea
        v-model="orderDescriptions"
        placeholder="توضیحات سفارش را اینجا بنویسید..."
        class="w-full"
      />

      <div class="flex justify-between items-center mb-4 sm:mb-6 gap-4">
        <vs-radio
          class="radio"
          vs-value="indoor"
          v-model="orderType"
          @input="onTypeChanged"
        >
          داخل سالن
        </vs-radio>
        <vs-radio
          class="radio"
          vs-value="outdoor"
          v-model="orderType"
          @input="onTypeChanged"
        >
          ارسالی
        </vs-radio>
        <vs-radio
          class="radio"
          vs-value="takeaway"
          v-model="orderType"
          @input="onTypeChanged"
        >
          تحویل در محل
        </vs-radio>
      </div>

      <div
        class="flex sm:gap-4 gap-2 mb-2 sm:mb-4 flex-col sm:flex-row items-start"
      >
        <div class="flex gap-1 flex-col flex-1 w-full">
          <select-user ref="selectUserRef" v-model="user"></select-user>
          <p class="user-name">
            نکته: در صورت عدم وارد کردن شماره همراه کاربر، به صورت پیش فرض شماره
            متصدی ثبت خواهد شد.
          </p>
        </div>
        <template v-if="orderType === 'indoor'">
          <div
            v-if="tables && Array.isArray(tables) && tables.length > 0"
            class="table-input-wrapper flex-1 w-full"
          >
            <vs-input
              :value="table ? table.title : ''"
              :disabled="true"
              placeholder="شماره میز مشتری"
              class="table-input"
            />

            <vs-button @click="tablesListVisible = true" class="table-btn">
              شماره میزها
            </vs-button>
          </div>
          <div v-else class="table-input-wrapper flex-1 w-full">
            <vs-input
              v-model="deskNumber"
              placeholder="شماره میز مشتری"
              class="table-input"
            />

            <router-link to="/tables" class="table-btn">
              مدیریت میزها
            </router-link>
          </div>
        </template>

        <div
          v-else-if="orderType === 'outdoor'"
          class="table-input-wrapper flex-1"
        >
          <vs-input
            v-model="address"
            @input="onAddressChanged"
            placeholder="آدرس مشتری"
            class="table-input"
          />

          <vs-button
            v-if="orderType === 'outdoor'"
            @click="providerZonesVisible = true"
            block
            class="table-btn"
          >
            لیست مناطق
          </vs-button>
        </div>
      </div>
      <vs-input
        v-if="orderType === 'outdoor'"
        v-model="deliveryFee"
        placeholder="هزینه پیک (ریال)"
        class="w-100 mb-2 sm:mb-4"
      >
      </vs-input>
      <div class="mb-6 sm:mb-8">
        <div class="w-100">
          <div class="discount-box">
            <div class="discount-select-wrapper">
              <vs-select
                v-model="discountType"
                @input="onDiscountTypeChanged"
                :disabled="!canDiscount"
                class="discount-select"
                width="100%"
              >
                <vs-select-item value="amount" text="مبلغ تخفیف" />
                <vs-select-item value="percentage" text="درصد تخفیف" />
              </vs-select>
            </div>
            <input
              v-model="discount"
              :type="discountType === 'percentage' ? 'number' : 'text'"
              :disabled="!canDiscount"
              class="discount-input"
              :placeholder="
                discountType === 'percentage' ? 'درصد تخفیف' : 'مبلغ تخفیف'
              "
            />
            <span class="discount-unit">
              {{ discountType === "percentage" ? "%" : "ریال" }}
            </span>
            <vs-button
              radius
              color="danger"
              type="flat"
              icon-pack="feather"
              icon="icon-trash-2"
              class="remove-discount-btn"
              @click="removeDiscount"
            ></vs-button>
          </div>
          <span v-if="!canDiscount" class="discount-hint">
            برای اعمال تخفیف روی فاکتور دسترسی ندارید.
          </span>
        </div>
      </div>
      <invoice-element
        title="تعداد آیتم‌ ها"
        isCount
        extraClass="text-base font-bold"
        :value="shoppingCardProductsCount"
      />
      <invoice-element title="مجموع سفارش" :value="getSum()" />
      <invoice-element
        v-if="getDiscountAmount() > 0"
        title="تخفیف"
        :value="getDiscountAmount()"
      />
      <invoice-element
        v-if="addVat"
        :title="'مالیات بر ارزش افزوده ' + `(${TAX_LABEL})`"
        :value="getTax()"
      />
      <invoice-element
        title="هزینه پیک"
        :value="getDeliveryFee()"
        :orderType="orderType"
        :isDelivery="true"
      />
      <vs-divider class="mb-5 mt-0"></vs-divider>
      <invoice-element isBold title="مبلغ پرداختی" :value="getPaidPrice()" />
    </div>
    <div
      class="flex flex-col sm:flex-row justify-start gap-4 w-full mt-4 sm:mt-6"
    >
      <vs-button
        @click="confirmOrder()"
        color="primary"
        class="flex-1 text-base font-bold"
        block
        icon-pack="feather"
        icon="icon-check"
      >
        تایید و ثبت نهایی سفارش
      </vs-button>
      <vs-button
        v-if="
          providerInfo.hasActivePaymentGateway &&
          user &&
          user.phone &&
          user.phone.length === 11
        "
        @click="sendOrderLink()"
        color="primary"
        class="flex-1 text-base font-bold"
        block
        type="border"
        icon-pack="feather"
        icon="icon-send"
      >
        ارسال فاکتور و لینک پرداخت
      </vs-button>
    </div>

    <vs-popup title="مناطق سرویس دهی" :active.sync="providerZonesVisible">
      <provider-zones-list @selectZone="selectZone" />
    </vs-popup>

    <vs-popup title="لیست شماره میزها" :active.sync="tablesListVisible">
      <tables-list @onTableSelected="onTableSelected" :tables="tables" />
    </vs-popup>

    <vs-popup
      title="انتخاب زمان ارسال سفارش"
      :active.sync="showChooseTimePopup"
    >
      <preparation-time ref="preparationTime" />
      <vs-button
        @click="submitOrder()"
        class="mt-4"
        color="primary"
        type="filled"
        >تایید نهایی سفارش</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
  import orderApiService from "../../../../services/api/OrderApiService";
  import { mapGetters } from "vuex";
  import InvoiceElement from "./InvoiceElement.vue";
  import SelectUser from "../SelectUser.vue";
  import providerApiService from "../../../../services/api/ProviderApiService";
  import authService from "../../../../services/AuthService";
  import ProviderZonesList from "./ProviderZonesList.vue";
  import PreparationTime from "../../PreparationTime.vue";
  import { convertToEnglishDigit } from "../../../../helpers/Functions";
  import { TAX_FEE, TAX_LABEL } from "../../../../helpers/Constants";
  import TablesList from "./TablesList.vue";

  export default {
    components: {
      InvoiceElement,
      SelectUser,
      ProviderZonesList,
      PreparationTime,
      TablesList,
    },
    name: "Category",
    data() {
      const orderType = localStorage.getItem("orderType");

      return {
        orderDescriptions: "",
        deskNumber: "", // This should be removed after a while
        table: null,
        tables: [],
        address: "",
        orderType: orderType || "indoor",
        discountType: "percentage",
        deliveryZone: null,
        deliveryFee: null,
        addVat: false,
        user: null,
        discount: null,
        canDiscount: true,
        providerZonesVisible: false,
        providerInfo: {},
        showChooseTimePopup: false,
        tablesListVisible: false,
        TAX_LABEL,
        cart: { ...this.shoppingCardInfo },
        isAutoSettle: false,
      };
    },
    created() {
      if (this.order) {
        this.user = this.order.user;
      }
      if (this.order) {
        this.orderType = this.order.type;
        this.orderDescriptions = this.order.userDetails.description;

        if (+this.order.discount > 0) {
          // The invoice stores an amount. Reading it back as a rounded
          // percentage rewrote the customer's discount on every save, and now
          // makes the API read an untouched invoice as a discount change.
          this.discountType = "amount";
          this.discount = (+this.order.discount).toString();
        }

        if (this.order.type === "indoor") {
          this.deskNumber = this.order.userDetails?.destination; // This should be removed after a while
          this.table = this.order.table;
        } else {
          this.address = this.order.userDetails.destination;
          if (this.order.userDetails.delivery) {
            this.deliveryFee = +this.order.userDetails.delivery.fee
              .toString()
              .splitNumberFormat();
          }

          if (this.order.userDetails.destination === "تحویل در محل مجموعه") {
            this.takeInProviderPlace = true;
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),

      shoppingCardProductsCount() {
        let count = 0;
        this.shoppingCardInfo.products.forEach((item) => {
          count += item.unit;
        });
        return count;
      },
    },
    props: {
      shoppingCardInfo: {
        type: Object,
        requried: true,
      },
      order: {
        type: Object,
      },
    },
    watch: {
      discount(newValue) {
        if (this.discountType === "percentage") {
          if (newValue < 0) {
            this.discount = null;
          } else if (newValue >= 0 && newValue <= 100) {
            this.discount = convertToEnglishDigit(newValue);
          } else if (newValue > 100) {
            this.discount = 100;
          }
        } else {
          if (!newValue) {
            this.discount = null;
            return;
          }
          let cleanedValue = convertToEnglishDigit(newValue) || newValue;
          // Filter out non-numeric characters (allow numbers only)
          cleanedValue = cleanedValue.replace(/[^0-9]/g, "");

          const numericValue = +cleanedValue;

          // The cart can still be empty while an invoice is being loaded, and
          // an empty cart is not a reason to wipe its discount.
          if (this.getSum() > 0 && numericValue > this.getSum()) {
            this.$nextTick(() => {
              this.discount = this.getSum() + this.getTax();
            });
            return;
          }

          this.discount = cleanedValue
            .toString()
            .splitNumberFormat()
            .numberFormat();
        }
      },
      deliveryFee(newValue) {
        if (!newValue) {
          this.deliveryFee = null;
          return;
        }
        const cleanedValue = convertToEnglishDigit(newValue) || newValue;
        this.deliveryFee = cleanedValue
          .toString()
          .splitNumberFormat()
          .numberFormat();
      },
      orderType(newValue) {
        localStorage.setItem("orderType", newValue);
      },
    },
    methods: {
      /**
       * Whether this account may discount an invoice. The controls start
       * enabled and are only ever closed by an answer: the API is the real
       * gate, and a field that flickers shut reads as a bug.
       */
      readDiscountAbility() {
        if (authService.privileged === true) return;

        providerApiService
          .getEmployeeAbilities(this.currentProvider.id, authService.id)
          .then((res) => {
            const abilities = (res && res.data) || [];

            const hasWildcard = abilities.some(
              (ability) => ability.scope === "*" && ability.value
            );

            const discount = abilities.find(
              (ability) =>
                ability.scope === "orders" && ability.action === "discount"
            );

            this.canDiscount =
              hasWildcard || (discount && discount.value === true);
          })
          .catch(() => {});
      },

      getProviderTables() {
        providerApiService
          .getProviderTablesList(this.currentProvider.id)
          .then((result) => {
            this.tables = result.data;
          });
      },
      resetData() {
        this.orderDescriptions = "";
        this.deskNumber = ""; // This should be removed after a while
        this.table = null;
        this.address = "";
        this.orderType = "indoor";
        this.deliveryZone = null;
        this.deliveryFee = null;
        this.user = null;
        this.discount = null;
        this.providerZonesVisible = false;
        this.showChooseTimePopup = false;

        this.$refs["selectUserRef"].clear();
      },
      onTypeChanged(type) {
        if (type !== "outdoor") {
          this.deliveryZone = null;
          this.deliveryFee = null;
        }
        if (type === "takeaway") {
          this.address = "تحویل در محل مجموعه";
        } else {
          this.address = "";
        }
      },
      onDiscountTypeChanged() {
        this.discount = null;
      },
      removeDiscount() {
        this.discount = null;
      },
      onAddressChanged(value) {
        if (value.length === 0) {
          this.deliveryZone = null;
        }
      },
      getSum() {
        let price = 0;
        this.shoppingCardInfo.products.forEach((element) => {
          const discount = +element.product.discount || 0;
          const finalPrice =
            +element.product.price - +element.product.price * (+discount / 100);
          price += finalPrice * element.unit;
        });
        return price;
      },
      getDiscountAmount() {
        let discountValue = this.discount;
        if (discountValue && typeof discountValue === "string") {
          discountValue = discountValue.splitNumberFormat();
        }
        discountValue = +discountValue;

        // Return 0 if discount is not a valid positive number
        if (isNaN(discountValue) || discountValue <= 0) {
          return 0;
        }

        if (this.discountType === "percentage") {
          return this.getSum() * (discountValue / 100);
        } else {
          return discountValue;
        }
      },
      getTax() {
        if (!this.addVat) {
          // When tax calculation is not enabled in settings
          return 0;
        }

        const sum = this.getSum();
        let tax = sum * TAX_FEE;
        return Number(tax.toFixed(2));
      },
      getDeliveryFee() {
        if (!this.deliveryFee) return 0;
        const numericValue = +this.deliveryFee.toString().splitNumberFormat();
        return numericValue > 0 ? numericValue : 0;
      },
      getPaidPrice() {
        return (
          this.getSum() +
          this.getTax() +
          this.getDeliveryFee() -
          this.getDiscountAmount()
        );
      },
      confirmOrder() {
        if (this.orderType === "outdoor") {
          this.showChooseTimePopup = true;
          return;
        }

        this.submitOrder();
      },
      submitOrder() {
        this.createOrder(
          "approved",
          "offline",
          this.orderType === "outdoor"
            ? this.$refs.preparationTime?.getTime()
            : null
        )
          .then((res) => {
            this.$vs.notify({
              text: res.message,
              color: "success",
              position: "bottom-center",
            });

            // Fire auto-settlement in the background; don't block the UI on it.
            this.checkAndSettlePayment(res.resource.id);

            this.finalizeOrder();
          })
          .catch(() => {})
          .finally(() => this.$vs.loading.close());
      },
      async checkAndSettlePayment(orderId) {
        try {
          if (this.isAutoSettle) {
            await orderApiService.autoSettlePayment(
              this.currentProvider.id,
              orderId
            );
          }
        } catch (err) {
          console.error("Auto settlement check failed", err);
        }
      },
      finalizeOrder() {
        this.$emit("close");
        this.resetData();

        setTimeout(() => {
          if (this.order) {
            // Edit order callback
            this.$router.replace("/order/list");
          } else {
            // Create order callback
            this.$emit("resetData");
          }
        }, 100);
      },
      createOrder(status, paymentType, preparationTime) {
        return new Promise((resolve, reject) => {
          const { orderDescriptions, deskNumber, table, address, orderType } =
            this;

          if (!orderType) {
            this.$vs.notify({
              text: "لطفا نوع سفارش را انتخاب کنید",
              color: "warning",
              position: "bottom-center",
            });
            return reject();
          }

          if (orderType === "indoor" && deskNumber === "" && !table) {
            this.$vs.notify({
              text: "لطفا شماره میز را وارد کنید",
              color: "warning",

              position: "bottom-center",
            });
            return reject();
          }

          if (orderType === "outdoor") {
            if (address === "") {
              this.$vs.notify({
                text: "لطفا آدرس را وارد کنید",
                color: "warning",
                position: "bottom-center",
              });
              return reject();
            }
          }

          /**
           * Allow sending print notification when creating order.
           */
          let sendPrintNotification = true;

          /**
           * Prevent sending notification when editing order.
           */
          if (this.order?.id) {
            sendPrintNotification = false;

            /**
             * Allow sending notification when any items has changed
             */
            if (
              this.areArraysDifferent(
                this.cart.products,
                this.shoppingCardInfo.products
              )
            ) {
              sendPrintNotification = true;
            }
          }

          this.$vs.loading();

          orderApiService
            .createOrEditOrder(
              this.order ? this.order.id : null,
              this.currentProvider.id,
              this.user ? this.user.phone : null,
              this.getSum(),
              this.getDiscountAmount(),
              this.shoppingCardInfo.products,
              orderDescriptions,
              deskNumber,
              table?.id,
              address,
              orderType,
              this.deliveryFee,
              status,
              paymentType,
              preparationTime,
              true, // isIntentionalChange
              sendPrintNotification
            )
            .then(resolve)
            .catch((err) => {
              this.$vs.notify({
                text: err.getErrorDescriptions(),
                color: "danger",
                position: "bottom-center",
              });

              this.$vs.loading.close();
              reject(err);
            });
        });
      },
      sendOrderLink() {
        if (this.user && this.user.phone.length !== 11) {
          this.$vs.notify({
            text: "لطفا شماره همراه کاربر را به صورت کامل وارد نمایید.",
            color: "warning",
            position: "bottom-center",
          });
          return;
        }

        this.createOrder("payment_required", "online")
          .then((orderResult) => {
            orderApiService
              .sendOrderLink(this.currentProvider.id, orderResult.resource.id)
              .then((res) => {
                this.$emit("close");
                this.resetData();

                this.$vs.notify({
                  text: res.message,
                  color: "success",
                  position: "bottom-center",
                });

                setTimeout(() => {
                  if (this.order) {
                    // Edit order callback
                    this.$router.replace("/order/list");
                  } else {
                    // Create order callback
                    this.$emit("resetData");
                  }
                }, 100);
              })
              .catch((err) => {
                this.$vs.notify({
                  text: err?.getErrorDescriptions(),
                  color: "danger",
                  position: "bottom-center",
                });
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          })
          .catch(() => {});
      },
      getProviderSettings() {
        providerApiService
          .getSettings(this.currentProvider.id)
          .then((result) => {
            result?.forEach((element) => {
              if (element.key === "calculate-vat") {
                this.addVat = element.value;
              } else if (element.key === "automatic-order-settlement") {
                this.isAutoSettle = element.value;
              }
            });
          });
      },
      getProviderInfo() {
        providerApiService
          .providerProfile(this.currentProvider.id)
          .then((providerInfo) => {
            this.providerInfo = providerInfo;
          });
      },
      selectZone(zone) {
        this.providerZonesVisible = false;

        if (this.deliveryZone) {
          const zoneLength = this.deliveryZone.title.length;
          const _text = this.address.substring(zoneLength + 3);
          this.address = _text;
        }

        this.address = zone.title + " - " + this.address;
        this.deliveryFee = +zone.fee;
        this.deliveryZone = zone;
      },
      onTableSelected(table) {
        this.tablesListVisible = false;
        this.table = table;
      },
      areArraysDifferent(arr1, arr2) {
        // Check if the lengths are different
        if (arr1.length !== arr2.length) {
          return true;
        }

        // Sort arrays by product ID (assuming product.id exists)
        arr1.sort((a, b) => a.product.id - b.product.id);
        arr2.sort((a, b) => a.product.id - b.product.id);

        // Compare each element in both arrays
        for (let i = 0; i < arr1.length; i++) {
          // Check if the product.id or unit are different
          if (
            arr1[i].product.id !== arr2[i].product.id ||
            arr1[i].unit !== arr2[i].unit
          ) {
            return true;
          }
        }

        // If no differences found
        return false;
      },
    },
    mounted() {
      this.getProviderSettings();
      this.getProviderInfo();
      this.getProviderTables();
      this.readDiscountAbility();
    },
  };
</script>

<style scoped lang="scss">
  .discount-hint {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    opacity: 0.75;
  }

  .user-name {
    flex: 1;
    font-weight: 700;
    color: #f54c40;
    font-size: 9px;
    margin-bottom: 4;
  }
  .radio {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    font-size: 12px;
  }

  .table-input-wrapper {
    position: relative;
    width: 100%;
  }

  .table-input {
    width: 100%;

    ::v-deep input {
      height: 44px;
      padding-right: 120px !important;
    }
  }

  .table-btn {
    position: absolute;
    right: 6px;
    top: 50%;
    transform: translateY(-50%);
    height: 32px;
    padding: 0 14px;
    background: #0b1440;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    white-space: nowrap;
  }

  .discount-box {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 0;
    width: 100%;
    height: 44px;
    overflow: hidden;
    position: relative;
    background: white;

    .discount-select-wrapper {
      height: 100%;
      border-left: 1px solid rgba(0, 0, 0, 0.2);
      flex-shrink: 0;
      width: 110px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      // Adjust vs-select to fit inside the wrapper seamlessly
      .discount-select {
        width: 100%;
        margin: 0;

        ::v-deep .vs-select--input {
          border: none !important;
          box-shadow: none !important;
          background: transparent !important;
          padding: 0 5px 0 10px !important; // Right 5px, Left 20px for icon
          height: 100%;
          font-family: inherit;
          cursor: pointer;
          text-align: left !important;
          margin: 0;
        }
        ::v-deep .vs-select--icon {
          font-size: 16px;
          top: 50%;
          transform: translateY(-50%);
          left: auto !important;
        }
      }
    }

    .discount-input {
      flex-grow: 1;
      border: none;
      outline: none;
      padding: 0 10px;
      height: 100%;
      min-width: 0; // Allow shrinking
      width: auto;
      background: transparent;
    }

    .discount-unit {
      padding: 0 5px;
      color: #666;
      font-size: 14px;
      flex-shrink: 0;
      white-space: nowrap;
    }

    .remove-discount-btn {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      margin: 0 !important;
      border-radius: 0;
      flex-shrink: 0;
    }
  }

  @media (max-width: 440px) {
    .discount-box {
      .discount-select-wrapper {
        width: 100px;

        .discount-select ::v-deep .vs-select--input {
          padding: 0 2px 0 15px !important;
          font-size: 12px;
        }
      }
      .discount-input {
        padding: 0 5px;
        font-size: 12px;
      }
      .discount-unit {
        font-size: 12px;
        padding: 0 2px;
      }
    }
  }
</style>
